<div class="game-page-container">
  <div class="game-content-wrapper">
    <ng-container *ngIf="gameDetails">
      <!-- Image Banner Section -->
      <div class="banner-section">
        <img
          class="game-banner-image"
          [src]="gameDetails.OutsidePortalImageUrl | contentImage: '7'"
          alt="Quiz of the Month Banner"
        />
      </div>

      <!-- Tab Navigation Section -->
      <div
        class="game-tab-navigation"
        tabindex="0"
        #tabNavigation
        *ngIf="
          (gameDetails.Questions?.length > 0 ? 1 : 0) + (gameDetails.Rules ? 1 : 0) + (gameDetails.TermsAndConditions ? 1 : 0) >=
          2
        "
      >
        <button
          *ngIf="gameDetails.Questions?.length > 0"
          class="game-tab-button"
          [class.game-tab-button--active]="activeTab === 0"
          (click)="setActiveTab(0)"
          [attr.aria-selected]="activeTab === 0"
          role="tab"
        >
          {{ 'fgbcl.outside.portal.game.tab.play.title' | translate }}
        </button>

        <button
          *ngIf="gameDetails.Rules"
          class="game-tab-button"
          [class.game-tab-button--active]="activeTab === 1"
          (click)="setActiveTab(1)"
          [attr.aria-selected]="activeTab === 1"
          role="tab"
        >
          {{ 'fgbcl.outside.portal.game.tab.rules.title' | translate }}
        </button>

        <button
          *ngIf="gameDetails.TermsAndConditions"
          class="game-tab-button"
          [class.game-tab-button--active]="activeTab === 2"
          (click)="setActiveTab(2)"
          [attr.aria-selected]="activeTab === 2"
          role="tab"
        >
          {{ 'fgbcl.outside.portal.game.tab.terms.and.conditions.title' | translate }}
        </button>
      </div>

      <!-- Tab Content Section -->
      <div class="game-tab-content" role="tabpanel">
        <div *ngIf="activeTab === 0" class="tab-panel">
          <div *ngIf="isFormSubmitted" class="success-message-container">
            <div class="success-icon">
              <i class="ki-check-circle-fill text-success" style="font-size: 48px"></i>
            </div>
            <h2 class="success-title text-success">{{ 'fgbcl.outside.portal.game.success.title' | translate }}</h2>
            <p class="success-description">
              {{ 'fgbcl.outside.portal.game.success.description' | translate }}
            </p>
          </div>
          <ng-container *ngIf="gameDetails && gameDetails.Questions.length > 0 && !isFormSubmitted">
            <ng-container *ngIf="groupType == groupTypes.Trivia">
              <fgbcl-game-trivia-question-list (isGameCompleted)="isGameCompleted($event)" [isExternal]="true" [gameDetails]="gameDetails" [groupId]="groupId">
                <ng-template #customContent>
                  <ng-container *ngTemplateOutlet="submissionFormTemplate"></ng-container>
                </ng-template>
              </fgbcl-game-trivia-question-list>
            </ng-container>

            <ng-container *ngIf="groupType == groupTypes.Predictor">
              <div>
                <fgbcl-game-predictor-question-list
                  [predictorStatus]="predictorStatus"
                  [predictor]="gameDetails"
                  [groupId]="groupId"
                  [endDate]="gameDetails.EndDate"
                  [isExternal]="true"
                  (externalPredictorSubmitted)="externalPredictorSubmitted($event)"
                >
                  <ng-template #submissionFormContent>
                    <ng-container *ngTemplateOutlet="submissionFormTemplate"></ng-container>
                  </ng-template>
                </fgbcl-game-predictor-question-list>
              </div>
            </ng-container>

            <ng-container *ngIf="groupType == groupTypes.Poll">
              <div>
                <fgbcl-game-polls-question-list [pollsQuestions]="gameDetails.Questions" [groupId]="groupId" [isExternal]="true">
                  <ng-template #submissionFormContent>
                    <ng-container *ngTemplateOutlet="submissionFormTemplate"></ng-container>
                  </ng-template>
                </fgbcl-game-polls-question-list>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div *ngIf="activeTab === 1 && gameDetails.Rules" class="tab-panel">
          <div class="game-rules-content" [innerHtml]="gameDetails.Rules | safeHtml"></div>
        </div>
        <div *ngIf="activeTab === 2 && gameDetails.TermsAndConditions" class="tab-panel">
          <div class="game-terms-content" [innerHtml]="gameDetails.TermsAndConditions | safeHtml"></div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!isLoading && !gameDetails">
      <div class="no-games-available-container">
        <div class="no-games-image-container">
          <img src="assets/images/games/NoGames.svg" alt="No Games Available" class="no-games-image" />
        </div>
        <h3 class="text-center no-games-title">
          {{ 'fgbcl.outside.portal.game.coming.soon.title' | translate }}
        </h3>
        <div class="text-center no-games-description">
          {{ 'fgbcl.outside.portal.game.coming.soon.description' | translate }}
        </div>
      </div>
    </ng-container>
  </div>
</div>
<!-- Submission form template -->
<ng-template #submissionFormTemplate>
  <fgb-submission-form
    [gameDetails]="gameDetails"
    [unauthorizedForm]="unauthorizedForm"
    [unauthorizedEntityCreated]="unauthorizedEntityCreated"
    [isFormSubmitting]="isFormSubmitting"
    (submitForm)="submitUnauthorizedForm()"
  ></fgb-submission-form>
</ng-template>
